import { createRouter, createWebHashHistory } from 'vue-router'
import store from "@/store";
import {getRankData} from "@/axios/api";
import mythicalBeast from "@/script/mythicalBeast";
import {isMobile} from "@/script/checkDevice";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'home',
    components:{
      default : () => import("../pages/MythicalBeastMap.vue"),
      navbar: () => import("../views/NavbarMenu.vue"),
    },
    beforeEnter: () => {
      store.commit("setLoading",true);
    },
    children: [
      {
        path: "mythical-beast-preview/:id",
        name: "mythical-beast-preview",
        component: () => import("../pages-components/BeastDetailPreview.vue"),
        beforeEnter: (to,from,next) => {

          //navbar
          store.commit("onClickedMenu", false);

          //router
          if(from.name === undefined && to.name === "mythical-beast-preview"){
            next("/home");
          } else {

            if(from.name === "home" && to.name === "mythical-beast-preview"){
              next();
            }else{
              next("/home");
            }
          }
        }
      },
    ]
  },
  {
    path: "/vote-result/:id",
    name: "vote-result",
    component: () => import("../pages-components/voteResult.vue"),
    props: (route) => route.params,
    beforeEnter: async (to, from, next) => {
      // console.log(from.name);
      // console.log(from.params.id);
      if (from.name === 'mythical-beast-preview' && to.name === "vote-result" ||
          from.name === 'home' && to.name === "vote-result"
      ) {

        // to.params.id = from.params.id;

        store.commit("setLoading", true);
        const responseData = await getRankData();
        mythicalBeast.rankDatas = responseData.rankData;
        next();
      } else {
        next("/home");
      }
    }
  },
  {
    path: "/mythical-beasts",
    name: "mythical-beasts",
    components: {
      default : ()=> import("../pages/MythicalBeasts.vue"),
      navbar : () => import("../views/NavbarMenu.vue"),
    },
    children: [
      {
        path: "mythical-beast/:id",
        name: "mythical-beast-detail-preview",
        component: () => import("../pages-components/mythicalBeastDetailPreview.vue"),
        beforeEnter: (to,from,next) => {
          if(to.name === "mythical-beast-detail-preview"){
            if(isMobile()){
              // console.log(to.params.id);
              next(`mythical-beast/${to.params.id}`);
            }else{
              next();
            }
          }
        }
      }
    ],
    // eslint-disable-next-line
    beforeEnter: async (to,from,next) => {
      if(to.name === "mythical-beasts" || to.name === "mythical-beast-detail-preview") {
        store.commit("setLoading",true);
        const responseData = await getRankData();
        // store.commit("setLoading",false);
        mythicalBeast.rankDatas = responseData.rankData;

        next();
      }
    }
  },
  {
    path: "/mythical-beast/:id",
    name: "mythical-beast-detail",
    components: {
      default : () => import("../pages/MythicalBeastDetail.vue"),
      navbar : () => import("../views/NavbarMenu.vue"),
    },
    beforeEnter: async (to,from,next) => {
      if(to.name === "mythical-beast-detail") {
        store.commit("setLoading",true);
        const responseData = await getRankData();
        // store.commit("setLoading",false);
        // setScroll();
        mythicalBeast.rankDatas = responseData.rankData;

        if(isMobile()){
          next();
        } else {
          next(`/mythical-beasts/mythical-beast/${to.params.id}`)
        }
      }
    }
  },
  {
    name: "portfolio",
    path: "/portfolio",
    components: {
      default: ()=>import("../pages/PortfolioView.vue"),
      navbar : ()=> import("../views/NavbarMenu.vue"),
    },
    beforeEnter: () => {
      store.commit("setLoading",true);
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import("../pages/NotFound.vue")
  },

]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // console.log(to.hash);
      const targetElement = document.querySelector(to.hash);

      // console.log(targetElement);
      store.commit("onClickedMenu", false);

      if (targetElement) {
        const menu = document.querySelector('#menu');
        if(menu == null){
          return;
        }
        const offset = menu.offsetHeight;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
        // const targetPosition = targetElement.getBoundingClientRect().top;

        setTimeout(()=>{
          // console.log(targetPosition);
          window.scroll({
            top: targetPosition,
            behavior: "auto"
          })
          // window.scroll(0,targetPosition);
        },100);
      }
    }
    // else{
    //   return {x: 0, y: 0};
    // }

    // if (from.name === "home" && to.name === "mythical-beast-preview") {
    //   // window.scroll(0,0);
    //   window.scrollTo({
    //     top: -window.scrollY,
    //     behavior: "auto"
    //   });
    // }

  },
})
// eslint-disable-next-line
router.beforeEach(async (to, from, next) => {
  if (
      to.name === "mythical-beast-detail" ||
      to.name === "mythical-beasts" ||
      to.name === "home" ||
      to.name === "portfolio"
  ) {

    //initial setting
    store.commit("onClickedMenu", false);
    // console.log(to.name);
    // console.log(document.body.classList)

    next();
  }else{
    next();
  }
})

export default router
